import { query } from "@lookiero/messaging";
const LIST_NOTIFICATIONS = "list_notifications";
const listNotifications = () => query({ name: LIST_NOTIFICATIONS });
const listNotificationsHandler = ({ view }) => async () => view();
export { LIST_NOTIFICATIONS, listNotifications, listNotificationsHandler };
